import { useEffect, useRef } from "react";
import { useLanguage } from "@/lib/LanguageContext";

export default function Hero() {
    const { t } = useLanguage();
    const canvasWrapRef = useRef(null);
    useEffect(() => {
        if (!canvasWrapRef.current) return;
        // three.js se carga en un chunk aparte para no bloquear el primer render
        let scene = null;
        let io = null;
        let cancelled = false;
        const onMove = (e) => {
            const x = (e.clientX / innerWidth) * 2 - 1;
            const y = -((e.clientY / innerHeight) * 2 - 1);
            scene?.setPointer(x, y);
        };
        const onScroll = () => {
            const hero = document.getElementById("hero");
            if (!hero) return;
            const rect = hero.getBoundingClientRect();
            const h = rect.height || innerHeight;
            scene?.setScroll(Math.min(1, Math.max(0, -rect.top / h)));
        };
        import("@/three/heroScene").then(({ createHeroScene }) => {
            if (cancelled || !canvasWrapRef.current) return;
            scene = createHeroScene(canvasWrapRef.current);
            io = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting ? scene.resume() : scene.pause()), { threshold: 0.01 });
            io.observe(canvasWrapRef.current);
            onScroll();
        });
        window.addEventListener("mousemove", onMove);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => {
            cancelled = true;
            window.removeEventListener("mousemove", onMove);
            window.removeEventListener("scroll", onScroll);
            io?.disconnect(); scene?.dispose();
        };
    }, []);
    return (
        <section id="hero" className="ps-hero" data-testid="hero-section">
            <div ref={canvasWrapRef} aria-hidden="true" data-testid="hero-canvas-wrap" style={{ position: "absolute", inset: 0, zIndex: 1 }} />
            <div className="ps-container ps-hero-content">
                <div className="ps-hero-tag ps-mono ps-fade" data-hero-fade data-testid="hero-tag">
                    <span className="dot" />
                    <span>{t.hero.tag}</span>
                </div>
                <h1 className="ps-display ps-hero-title" data-split data-hero-title data-testid="hero-title"
                    dangerouslySetInnerHTML={{ __html: t.hero.title }} />
                <div className="ps-hero-meta">
                    <p className="ps-fade" data-hero-fade data-testid="hero-description">
                        {t.hero.description}
                    </p>
                </div>
            </div>
            <div className="ps-hero-scroll ps-mono ps-fade" data-hero-fade data-testid="hero-scroll-hint">
                <span>{t.hero.scrollHint}</span><span className="line" />
            </div>
        </section>
    );
}
